export default __webpack_public_path__ + "static/media/phoneIcon.b87fe320.svg";